import { render } from "./rewardBox.vue?vue&type=template&id=45a8e975&scoped=true&ts=true"
import script from "./rewardBox.vue?vue&type=script&lang=ts"
export * from "./rewardBox.vue?vue&type=script&lang=ts"

import "./rewardBox.vue?vue&type=style&index=0&id=45a8e975&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45a8e975"]])

export default __exports__